import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
interface IAppState {
  token: string;
  crmid: string;
}
const initialState: IAppState = {
  token: "",
  crmid: "",
};

export const getTokenGoogleCaptcha = createAsyncThunk(
  "ggCaptchaV3Token",
  async (token: any) => {
    return token;
  }
);

export const getCrmid = createAsyncThunk("Crmid", async (crmid: any) => {
  return crmid;
});

const appSlide = createSlice({
  name: "application",
  initialState,
  reducers: {
    addApp: (state, action: PayloadAction<any>) => {
      const data = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(getTokenGoogleCaptcha.fulfilled, (state, action: any) => {
      state.token = action.payload;
    });
    builder.addCase(getCrmid.fulfilled, (state, action: any) => {
      state.crmid = action.payload;
    });
  },
});

export const { addApp } = appSlide.actions;
const appReducer = appSlide.reducer;
export default appReducer;
